const HeaderDown = ({ children, margin }: any) => {
  return <div style={{ marginTop: margin ? margin : 22 }}>{children}</div>;
};
export default HeaderDown;
